
Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.SelectFieldList = function (fields, className) {

    this.fieldList = fields;
    this.elFieldList = document.createElement('div');
    this.elFieldList.className = 'MonetUIFilterBuilderSelectContainer ' + className;
    this.clickListeners = [];
    this.beforeCreateList = null;
    this.elementShowList;

    this.addClickEventListener = function (callback) {
        this.clickListeners.push(callback);
    };

    this.notifyClickEvent = function (field) {
        for (var i = 0, length = this.clickListeners.length; i < length; i++) {
            this.clickListeners[i](field,  this.elementShowList);
        }
    }.bind(this);

    this.getSelectedField = function () {
        return this.value;
    };

    this.setElementShowList = function (elementShowList) {
        this.elementShowList = elementShowList;
    };

    this.setSelectedField = function (field) {
        this.value = field;
        var selectPicker = $(this.elFieldList.querySelector('.pickListFieldFilters'));
        selectPicker.selectpicker('val', field.path);
        selectPicker.selectpicker('refresh');
        this.notifyClickEvent(field);
    };

    this.setFieldList = function (fieldList) {
        this.fieldList = fieldList;
    };

    this.createOptionField = function (field) {
        var translated = Monet.I18n.getResourcesByKey(field.label);
        var option = document.createElement('option');
        var fieldType = field.type;
        option.setAttribute('value', field.path);
        option.setAttribute('fileColumnNum', field.fileColumnNum);
        option.setAttribute('label', translated);
        option.setAttribute('type', fieldType);
        option.innerHTML = translated;
        return option;
    };

    this.renderFieldList = function () {

        var fragment = document.createDocumentFragment();
        var select = document.createElement('select');
        select.className = 'pickListFieldFilters fieldList';
        select.setAttribute('data-live-search', 'true');
        select.setAttribute('title', Monet.I18n.getResourcesByKey('Fields.NoSelected'));

        select.appendChild(this.createOptionField({ path: " ", label: " " }));

        for (var field in this.fieldList) {
            select.appendChild(this.createOptionField(this.fieldList[field]));
        }
        fragment.appendChild(select);

        return fragment;

    };

    this.createList = function () {

        if (this.beforeCreateList) {
            this.beforeCreateList(this.fieldList);
        }

        this.elFieldList.appendChild(this.renderFieldList());

        var pickList = $(this.elFieldList.querySelector('.pickListFieldFilters'));
        pickList.selectpicker({
            size: 7,
            callback: function (val) {
                var field = this.fieldList[val];
                if (field) {
                    this.value = field;
                } else {
                    this.value = '';
                }
                this.notifyClickEvent(field, this.value);
            }.bind(this),
            liveSearchNormalize: true
        });

        pickList.selectpicker('refresh');
        pickList.selectpicker('show');
    };

    this.render = function () {

        this.createList();

        return this.elFieldList;

    };

};